import { imageUrlBuilder, portableTextSerializer } from '@/utils/helpers';
import styles from './styles.module.css';
import BlockContent from '@sanity/block-content-to-react';

interface GridProps {
  heading: string;
  items: {
    title: string;
    content: string;
    textAlignment?: {
      alignment: 'left' | 'center' | 'right';
    };
    bgImage?: Record<string, unknown>;
  }[];
}

const Grid = ({ heading, items }: GridProps) => {
  return (
    <div className={styles.gridContainer}>
      {heading && <h2 className={styles.heading}>{heading}</h2>}
      <div className={styles.grid}>
        {items.map((item, index) => (
          <div key={index} className={styles.gridItem}>
            <div
              className={styles.icon}
              style={{
                backgroundImage: item.bgImage
                  ? `url(${imageUrlBuilder.image(item.bgImage.asset).width(128).auto('format').quality(80).url()})`
                  : 'none',
              }}
            ></div>
            <h3 className={styles.title}>{item.title}</h3>
            <div className={[styles.content, styles[item.textAlignment?.alignment || 'left']].join(' ')}>
              {Array.isArray(item.content) ? (
                <BlockContent blocks={item.content} serializers={portableTextSerializer} />
              ) : (
                <p className={styles.content}>{item.content}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Grid;
